import { StrategyTypes } from "../_enums/strategy-types.enum";
import {
    CustomStrategyOptions,
    MartingaleStrategyOptions,
    TreasuresStrategyOptions,
    WizardStrategyOptions,
} from "../_types/bot.type";

export function isMartingaleStrategyOptions(obj: unknown): obj is MartingaleStrategyOptions {
    return isStrategyOptionsBase(obj, StrategyTypes.Martingale);
}

export function isStrategyOptionsBase(obj: unknown, strategyType: StrategyTypes): boolean {
    return obj !== undefined && obj !== null && typeof obj === "object" && "type" in obj && obj.type === strategyType;
}

export function isTreasuresStrategyOptions(obj: unknown): obj is TreasuresStrategyOptions {
    return isStrategyOptionsBase(obj, StrategyTypes.Treasures);
}

export function isWizardStrategyOptions(obj: unknown): obj is WizardStrategyOptions {
    return isStrategyOptionsBase(obj, StrategyTypes.Wizard);
}

export function isCustomStrategyOptions(obj: unknown): obj is CustomStrategyOptions {
    return isStrategyOptionsBase(obj, StrategyTypes.Custom);
}
